import React, { useState, useEffect } from 'react';
import FilterContainer from './FilterContainer';
import DropdownContainer from './DropdownContainer';


function FilterAccordionSingleSelect(props) {
    const {
        taxonomy,
        taxSlug,
        selected,
        displayPostCounts,
        label,
        collapsible,
        scrollable,
        dropdown,
        postType,

        replaceSelected,
        isSelected
    } = props;


    const [closeRequest, setCloseRequest] = useState(false);
    const allTerms = [];
    const allTermsID = `${taxSlug}-all`;
    let parentContent;
    let childContent;
    let filterContent;

    function clickHandler(e, object) {
        e.preventDefault();
        let destination = '';
        let destAttr = '';
        let subject = '';
        let subAttr = '';
        let length = '';
        let lenAttr = '';
        let parametersString = '';
        let parameters = [];

        //params get
        const url = new URL(window.location.href);
        const dest = url.searchParams.get("dest");
        const sub = url.searchParams.get('sub');
        const len = url.searchParams.get('len');
        if(dest) {
            parameters.push(`dest=${dest}`);
        }
        if(sub) {
            parameters.push(`sub=${sub}`);
        }
        if(len) {
            parameters.push(`len=${len}`);
        }

        if (e.target.getAttribute('id').includes('destination')) {
            destination = e.target.getAttribute('data-id');
            destAttr = `dest=${destination}`;
            parameters = parameters.filter(el => !el.match(/dest=/g));
            parameters.push(destAttr);
        } else if (e.target.getAttribute('id').includes('subject')) {
            subject = e.target.getAttribute('data-id');
            subAttr = `sub=${subject}`;
            parameters = parameters.filter(el => !el.match(/sub=/g));
            parameters.push(subAttr);
        } else if (e.target.getAttribute('id').includes('length')) {
            length = e.target.getAttribute('data-id');
            lenAttr = `len=${length}`;
            parameters = parameters.filter(el => !el.match(/len=/g));
            parameters.push(lenAttr);
        }

        if (parameters.length > 0) {
            parametersString = `?${parameters.join("&")}`;
        }
        let newUrl = `${window.location.protocol}//${window.location.host}${window.location.pathname}${parametersString}`;
        window.history.replaceState(null, null, newUrl);



        replaceSelected(object.id, taxSlug);
    }

    function activeButtonClass(id) {
        let classString = '';

        if (isSelected(id, taxSlug)) {
            classString = 'active';
        }

        return classString;
    }

    if (taxonomy) {
        taxonomy.forEach(term => {
            if (displayPostCounts) {
                parentContent = `${term.name} (${term.count})`;
            }
            else {
                parentContent = term.name;
            }

            allTerms.push(
                <li key={term.id}>
                    <button
                        id={`${taxSlug}-${term.id}`}
                        data-id={term.id}
                        onClick={(e) => { clickHandler(e, term), setCloseRequest(true) }}
                        className={activeButtonClass(term.id)}
                    >
                        {parentContent}
                    </button>
                </li>
            )

            if (term.children) {
                term.children.forEach(child => {
                    if (displayPostCounts) {
                        childContent = `${child.name} (${child.count})`;
                    }
                    else {
                        childContent = child.name;
                    }

                    allTerms.push(
                        <li key={child.id}>
                            <button
                                id={`${taxSlug}-${child.id}`}
                                data-id={term.id}
                                onClick={(e) => { clickHandler(e, child), setCloseRequest(true) }}
                                className={activeButtonClass(child.id)}
                            >
                                {childContent}
                            </button>
                        </li>
                    )
                });
            }
        });
    }

    if (postType === 'post') {
        allTerms.push(
            <li key="all">
                <button
                    type="button"
                    id={allTermsID}
                    onClick={(e) => {
                        e.preventDefault();
                        replaceSelected(allTermsID, taxSlug);
                        setCloseRequest(true);
                    }}
                    className={activeButtonClass(allTermsID)}
                >
                    All {label}
                </button>
            </li>
        );
    }

    if (dropdown) {
        filterContent = <DropdownContainer
            selected={selected}
            taxSlug={taxSlug}
            taxonomy={taxonomy}
            closeRequest={closeRequest}
            setCloseRequest={setCloseRequest}
            defaultLabel={label}
            postType={postType}
        >
            <ul className="dropdown-list">
                {allTerms}
            </ul>
        </DropdownContainer>
    }
    else {
        filterContent = <ul>
            {allTerms}
        </ul>
    }

    return (
        <FilterContainer
            className="filter-accordion-single-select"
            label={label}
            collapsible={collapsible}
            scrollable={scrollable}
        >
            {filterContent}
        </FilterContainer>
    )
}

export default FilterAccordionSingleSelect;